import axios from "axios";
import { ApiConfig } from "../config/apiConfig";

export const downloadRegistrationAgreement = async (
  requestId: string,
  token: string,
  downloadPath?: string | null,
): Promise<Blob> => {
  const response = await axios.get(
    ApiConfig.registrationAgreementPdfUrl(downloadPath, requestId),
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
};
